// Sidebar.js
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faList, faPlus, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import './Sidebar.css';

const Sidebar = ({ isVisible }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };
  const buttonStyle = {
  
  textdecoration: 'none',
  color:'#fff',
  fontsize: '18px',
  padding: '10px',
  display: 'flex',
  alignitems: 'center',
  gap: '10px',
  backgroundColor: 'rgb(154, 57, 57)',
  border: 'none',
  cursor: 'pointer',
  textalign: 'left',
  }
  return (
    <div className={`sidebar ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="sidebar-header">
        <img src="logohome.png" alt="Logo" className="sidebar-logo" />
        {/* <h2 className="sidebar-name">Your Name</h2> */}
      </div>
      <nav>
        <ul>
          <li>
            <NavLink exact to="/" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faHome} className="nav-icon" />
              Home
            </NavLink>
          </li>

          <li>
            <NavLink exact to="/Admins" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Admins
            </NavLink>
          </li>

          <li>
            <NavLink exact to="/Users" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Users
            </NavLink>
          </li>
         
          
          <li>
            <NavLink to="/Brand" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Brands
            </NavLink>
          </li>

          <li>
            <NavLink to="/SubCategories" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Sub Categories
            </NavLink>
          </li>

          <li>
            <NavLink to="/Categories" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Categories
            </NavLink>
          </li>

         

          <li>
            <NavLink to="/Ads" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Slider images 
            </NavLink>
          </li>

          <li>
            <NavLink to="/Product" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Ads
            </NavLink>
          </li>

          <li>
            <NavLink to="/Packages" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Packages
            </NavLink>
          </li>

          <li>
            <NavLink exact to="/Coupons" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Coupons
            </NavLink>
          </li>

          <li>
            <NavLink exact to="/Notifications" className="nav-link" activeClassName="active">
              <FontAwesomeIcon icon={faList} className="nav-icon" />
              Notifications
            </NavLink>
          </li>

          
          <li>
            <button  style={buttonStyle} onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} className="nav-icon" />
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
